export default __webpack_public_path__ + "static/media/onBoarding.fb1da701.png";